/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Finnish
export default {
  'fabric.linkPicker.button.cancel': 'Peruuta',
  'fabric.linkPicker.button.insert': 'Lisää',
  'fabric.linkPicker.button.save': 'Tallenna',
  'fabric.linkPicker.clearLink': 'Tyhjennä',
  'fabric.linkPicker.clearLinkText': 'Tyhjennä teksti',
  'fabric.linkPicker.hyperlink.searchLinkResults': '{count, plural, =0 {tuloksia ei löytynyt} one {{count,number} tulos löytyi} other {{count,number} tulosta löytyi}}',
  'fabric.linkPicker.linkAriaLabel': 'Kirjoita tai liitä linkki kenttään',
  'fabric.linkPicker.linkHelperTextAriaLabel': 'Linkin näytön avustajan teksti',
  'fabric.linkPicker.linkHelperTextLabel': 'Anna tälle linkille otsikko tai kuvaus',
  'fabric.linkPicker.linkInvalid': 'Anna kelvollinen URL-osoite.',
  'fabric.linkPicker.linkLabel': 'Linkki',
  'fabric.linkPicker.linkPlaceholder': 'Liitä linkki',
  'fabric.linkPicker.linkTextAriaLabel': 'Linkin näyttöteksti',
  'fabric.linkPicker.linkTextLabel': 'Näytä teksti (valinnainen)',
  'fabric.linkPicker.linkTextPlaceholder': 'Näytettävä teksti',
  'fabric.linkPicker.listTitle.recentlyViewed': 'Äskettäin katsotut',
  'fabric.linkPicker.listTitle.results': 'Tulokset',
  'fabric.linkPicker.search.error.description': 'Päivitä sivu tai ota yhteyttä <a>Atlassian-tukeen</a>, jos ongelmat jatkuvat.',
  'fabric.linkPicker.search.error.heading': 'Tietojen lataamisessa ilmeni ongelmia.',
  'fabric.linkPicker.search.error.retry': 'Päivitä',
  'fabric.linkPicker.search.linkAriaLabel': 'Ehdotukset näytetään alla, kun alat kirjoittaa kenttään',
  'fabric.linkPicker.search.linkLabel': 'Hae tai liitä linkki',
  'fabric.linkPicker.search.linkPlaceholder': 'Etsi viimeaikaisia linkkejä tai liitä uusi linkki',
  'fabric.linkPicker.search.noResults.description': 'Yritä uudelleen eri hakutermillä.',
  'fabric.linkPicker.search.noResults.heading': 'Hakuasi vastaavia tuloksia ei löytynyt.',
  'fabric.linkPicker.status.submitting': 'Lähetetään',
  'fabric.linkPicker.time.message.updated': 'Päivitettiin {time}',
  'fabric.linkPicker.time.message.viewed': 'Katsottiin {time}',
  'fabric.linkPicker.unhandledError.description': 'Yritä ladata sivu uudelleen.',
  'fabric.linkPicker.unhandledError.heading': 'Jotain meni vikaan'
};